import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { ProjectTreeViewContainer } from "src/components/views/erp/project/treeView/ProjectTreeViewContainer.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/project/tree")({
	staticData: { title: i18n.t("tree_view"), legacyViewKey: "projectTreeViewPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <ProjectTreeViewContainer isActive={isActive} />;
}
